// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PN8f","colMin":"styles_colMin__2DUUq"};